export default function LoadingSplash({message}: { message?: string }) {
    return (
        <div className="grid min-h-screen place-items-center bg-white">
            <div className="flex items-center gap-3 text-gray-600">
                <svg className="h-5 w-5 animate-spin" viewBox="0 0 24 24" aria-hidden="true">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" opacity="0.25" />
                    <path d="M22 12a10 10 0 0 1-10 10" stroke="currentColor" strokeWidth="4" fill="none" />
                </svg>
                <span className="text-sm">
                    {message ?? "Loading..."}
                </span>
            </div>
        </div>
    );
}
